import React, { useEffect, useState, useRef } from 'react';
// Import images
import logoImage from '../assets/images/logo.png';
import home from '../assets/images/home.png';

// Import CSS files
import '../assets/css/lineicons.css';
import '../assets/css/datepicker.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/swiper2.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style2.css';

const Navbar = () => {
  const [hamburger2Active, setHamburger2Active] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [homeDropdownActive, setHomeDropdownActive] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Disable scrolling when dropdown is active
    if (homeDropdownActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setHomeDropdownActive(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [homeDropdownActive]);

  const toggleHamburgerMenu2 = () => {
    const nav2 = document.querySelector("body .hamburger-navigation2");
    const navMenu = document.querySelector("body .hamburger-navigation2 .nav-menu");
    const infoBox = document.querySelector("body .hamburger-navigation2 .info-box");
    const logo = document.querySelector("body .navbar .logo");
    const navbarText = document.querySelector("body .navbar .navbar-text");
    const siteMenu = document.querySelector("body .navbar .site-menu");
  
    if (hamburger2Active) {
      if (nav2) {
        nav2.style.transition = "";
        nav2.style.transitionDelay = "0.6s";
      }
      if (navMenu) navMenu.style.transitionDelay = "0s";
      if (infoBox) infoBox.style.transitionDelay = "0.2s";
      if (logo) logo.style.transitionDelay = "1.2s";
      if (navbarText) navbarText.style.transitionDelay = "1.2s";
      if (siteMenu) siteMenu.style.transitionDelay = "1.2s";
  
      setTimeout(() => {
        if (nav2) {
          nav2.style.top = "0";
          nav2.style.transition = "none";
        }
      }, 2000);
  
      const activeNav2 = document.querySelector("body.hamburger-navigation2-active .hamburger-navigation2");
      if (activeNav2) {
        activeNav2.style.top = "100vh";
      }
  
    } else {
      if (nav2) {
        nav2.style.transition = "";
        nav2.style.transitionDelay = "0s";
      }
      if (navMenu) navMenu.style.transitionDelay = "1.5s";
      if (infoBox) infoBox.style.transitionDelay = "1.7s";
      if (logo) logo.style.transitionDelay = "0s";
      if (navbarText) navbarText.style.transitionDelay = "0s";
      if (siteMenu) siteMenu.style.transitionDelay = "0s";
    }
  
    document.body.classList.toggle('hamburger-navigation2-active');
    setHamburger2Active(!hamburger2Active);
  };

  const toggleHomeDropdown = () => {
    setHomeDropdownActive(!homeDropdownActive);
  };
  
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = `
      @import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600;700&display=swap');
      
      body, .nav-menu, .info-box, .site-menu, .navbar, button, a {
        font-family: 'Jost', sans-serif !important;
      }
      
      .navbarzzz {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background-color: transparent !important;
        padding: 10px 0;
        transition: background-color 0.3s ease;
        z-index: 1000;
      }
      .navbarzzz.scrolled {
        background-color: #722628 !important;
      }
      
      .home-icon {
        display: none;
      }
      
      @media (min-width: 768px) {
        .home-icon {
          display: block;
          margin-left: 10px;
          position: relative;
        }
        .home-icon img {
          height: 20px;
          width: auto;
          cursor: pointer;
        }
      }
      
      @media (max-width: 991px) {
        .site-menu {
          display: none;
        }
        
        .hamburger-menu2 {
          display: block;
        }
        
        .hamburger-home-icon {
          display: block;
          margin: 10px 0;
        }
        .hamburger-home-icon img {
          height: 20px;
          width: auto;
        }
      }
      @media (min-width: 992px) {
        .hamburger-menu2 {
          display: none;
        }
        .hamburger-home-icon {
          display: none;
        }
      }
      
      .hamburger-navigation2 {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 8;
        transform: translateY(-100vh);
        transition: transform 0.7s ease;
        visibility: hidden;
        transition-delay: 0s;
      }
      body.hamburger-navigation2-active .hamburger-navigation2 {
        transform: translateY(0);
        visibility: visible;
        transition-delay: 0s;
      }
      .hamburger-navigation2 .layer {
        width: 100%;
        height: 100%;
        background: #270909;
        position: absolute;
        left: 0;
        top: 0;
      }
      
      .hamburger-menu2 svg path {
        fill: none;
        stroke: #fff;
        stroke-width: 6;
        transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
          stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
      }
      .hamburger-menu2 svg path.line1 {
        stroke-dasharray: 60 207;
        stroke-width: 6;
      }
      .hamburger-menu2 svg path.line2 {
        stroke-dasharray: 60 60;
        stroke-width: 6;
      }
      .hamburger-menu2 svg path.line3 {
        stroke-dasharray: 60 207;
        stroke-width: 6;
      }
      .hamburger-menu2 svg path.line1.opened {
        stroke-dasharray: 90 207;
        stroke-dashoffset: -134;
        stroke-width: 6;
      }
      .hamburger-menu2 svg path.line2.opened {
        stroke-dasharray: 1 60;
        stroke-dashoffset: -30;
        stroke-width: 6;
      }
      .hamburger-menu2 svg path.line3.opened {
        stroke-dasharray: 90 207;
        stroke-dashoffset: -134;
        stroke-width: 6;
      }
      
      .logo-home-container {
        display: flex;
        align-items: center;
      }

      /* Fullscreen Home Dropdown Menu Styles */
      .home-dropdown {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: #270909;
        z-index: 2000;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        overflow-y: auto;
      }

      .home-dropdown.active {
        opacity: 1;
        visibility: visible;
      }

      .dropdown-close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2001;
      }

      .dropdown-close::before,
      .dropdown-close::after {
        content: '';
        position: absolute;
        width: 30px;
        height: 2px;
        background-color: #fff;
      }

      .dropdown-close::before {
        transform: rotate(45deg);
      }

      .dropdown-close::after {
        transform: rotate(-45deg);
      }

      .home-dropdown-list {
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: center;
        width: 100%;
        max-width: 500px;
      }

      .home-dropdown-list li {
        margin-bottom: 25px;
      }

      .home-dropdown-list li:last-child {
        margin-bottom: 0;
      }

      .home-dropdown-list li a {
        color: #fff;
        font family: 'Poppins', sans-serif;
        font-size: 30px;
        text-decoration: none;
        display: block;
        transition: color 0.3s ease;
        font-weight: 400;
        letter-spacing: 1px;
      }

      .home-dropdown-list li a:hover {
        color: #722628;
      }

      .social-icons {
        display: flex;
        justify-content: center;
        margin-top: 40px;
      }

      .social-icons a {
        display: inline-flex;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: rgba(255,255,255,0.1);
        margin: 0 10px;
        color: #fff;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s ease;
        font-size: 20px;
      }

      .social-icons a:hover {
        background-color: rgba(255,255,255,0.2);
      }

      .dropdown-divider {
        height: 1px;
        background-color: rgba(255,255,255,0.2);
        margin: 40px 0;
        width: 80%;
        max-width: 400px;
      }

      .contact-us {
        text-align: center;
        margin-top: 30px;
      }

      .contact-us a {
        color: #fff;
        font family: Poppins, sans-serif;
        font-size: 30px;
        text-decoration: none;
        transition: color 0.3s ease;
        letter-spacing: 1px;
      }

      .contact-us a:hover {
        color: #722628;
      }

      /* Mobile styles for home dropdown */
      @media (max-width: 767px) {
        .home-icon {
          display: block;
          margin-left: 10px;
          position: relative;
        }
        
        .home-icon img {
          height: 20px;
          width: auto;
          cursor: pointer;
        }
        
        .home-dropdown-list li a {
          font-size: 20px;
        }
        
        .social-icons a {
          width: 40px;
          height: 40px;
          font-size: 18px;
        }
        
        .contact-us a {
          font-size: 18px;
        }
      }
    `;
    
    document.head.appendChild(styleElement);
    
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  return (
    <>
      <nav className="hamburger-navigation2">
        <div className="layer"></div>
        <div className="container">
          {/* <div className="hamburger-home-icon">
            <a href="/orayza"><img src={home} alt="Home" /></a>
          </div> */}
          <ul className="nav-menu mobile-menu">
            <li><a href="/">Home</a></li>
            <li><a href="/kent/accommodation">Rooms & Suites</a></li>
            <li><a href="/kent/dining">Dining</a></li>
            <li><a href="/kent/gallery">Gallery</a></li>
            <li><a href="/kent/offers">Offers</a></li>
            <li><a href="/kent/theKentCottage">Kent Cottage</a></li>
            <li><a href="/kent/contactus">Contact Us</a></li>
          </ul>
          <div className="info-box">
            <span>Follow Kent Cottage on Social Media</span>
            <ul className="nav-social">
              <li>
                <a href="https://web.facebook.com/kentcottage/" target="_blank" rel="noreferrer"><i className="lni lni-facebook-filled"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/kent_cottage/" target="_blank" rel="noreferrer"><i className="lni lni-instagram"></i></a>
              </li>
              <li>
                <a href="https://wa.me/94767008800" target="_blank" rel="noreferrer"><i className="lni lni-whatsapp"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      <nav className={`navbar navbarzzz ${scrolled ? 'scrolled' : ''}`}>
        <div className="container" style={{ margin: '0 0 0 5%' }}>
          <div className="logo-home-container">
            <div className="logo">
              <a href="/"><img src={logoImage} alt="Kent Cottage logo" style={{ height: '65px' }} /></a>
            </div>
            <div className="home-icon" ref={dropdownRef}>
              <img src={home} alt="Home" onClick={toggleHomeDropdown} />
              
              {/* Fullscreen Home Dropdown */}
              <div className={`home-dropdown ${homeDropdownActive ? 'active' : ''}`}>
                <button className="dropdown-close" onClick={toggleHomeDropdown} aria-label="Close menu"></button>
                
                <ul className="home-dropdown-list">
                  <li><a href="/oryza">ORYZA LEISURE</a></li>
                  <li><a href="/petti">PETTI PETTI MIRISSA</a></li>
                  <li><a href="/kent">KENT COTTAGE NUWARA ELIYA</a></li>
                  <li><a href="/banana-kandy">BANANA BUNKS KANDY</a></li>
                  <li><a href="/banana-mirissa">BANANA BUNKS MIRISSA</a></li>
                </ul>
                
                <div className="dropdown-divider"></div>
                
                <div className="contact-us">
                  <a href="/contact">Contact Us</a>
                </div>
                
                <div className="social-icons">
                  <a href="https://www.facebook.com" target="_blank" rel="noreferrer"><i className="lni lni-facebook-filled"></i></a>
                  <a href="https://www.instagram.com" target="_blank" rel="noreferrer"><i className="lni lni-instagram"></i></a>
                  <a href="https://wa.me/94767008800" target="_blank" rel="noreferrer"><i className="lni lni-whatsapp"></i></a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="site-menu">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/kent/accommodation">Rooms & Suites</a></li>
              <li><a href="/kent/dining">Dining</a></li>
              <li><a href="/kent/gallery">Gallery</a></li>
              <li><a href="/kent/offers">Offers</a></li>
              <li><a href="/kent/theKentCottage">Kent Cottage</a></li>
              <li><a href="/kent/contactus">Contact Us</a></li>
              <li style={{ marginTop: '-10px' }}>
                <a href="https://live.ipms247.com/booking/book-rooms-kentcottagenuwaraeliya" target="_blank" rel="noreferrer" className="custom-button-nav">BOOK YOUR STAY</a>
              </li>
            </ul>
          </div>
          <div className="hamburger-menu2 mobileon" style={{ marginLeft: '-40px' }}>
            <button className="menu" onClick={toggleHamburgerMenu2}>
              <svg width="45" height="45" viewBox="0 0 100 100">
                <path className={`line line1 ${hamburger2Active ? 'opened' : ''}`}
                  d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
                <path className={`line line2 ${hamburger2Active ? 'opened' : ''}`} d="M 20,50 H 80" />
                <path className={`line line3 ${hamburger2Active ? 'opened' : ''}`}
                  d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
              </svg>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;